// extracted by mini-css-extract-plugin
export default {"PageContainer":"UserAccountPage_PageContainer__R7WXp","Sidebar":"UserAccountPage_Sidebar__wKUN2","Content":"UserAccountPage_Content__gge+I"};